import React from 'react';
import {
    Show,
    TextField,
    DateField,
    SelectField,
    FunctionField
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import {Card, CardContent, Typography} from "@material-ui/core";
import ContractStatuses from "../helper/ContractStatuses";

const useStyles = makeStyles((theme) => ({
    separator: {
        width: '10px',
        clear: 'none'
    }
}));

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 200,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const ContractRequestShow = props => {
    const classes = useStyles();

    const ContractRequestShowTitle = ({ record }) => {
        return <span>Рецепт: {record ?`${record.medicationRequest.requestNumber}` : ''}</span>;
    };

    const Label = (prop) => {
        return (
            <span style={labelStyle}>{prop.caption}: </span>
        );
    }

    const contractStatus = (status) => {
        return status ? "Призупинений" : "Діючий";
    }

    const paymentMethod = {
        prepayment: "Попередня оплата",
        postage: "Післяплата"
    }

    return (
        <Show className="show-styles" {...props} title={<ContractRequestShowTitle/>}>
            <div style={{ margin: '1em' }}>
                <div className="legal-entity-list-show">
                    <Card style={cardStyle}>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер рецепту"}/>
                            <TextField source="medicationRequest.requestNumber"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Сума чеку"}/>
                            {/*<TextField source="paymentAmount"  />*/}
                            <FunctionField
                                render={record => record.paymentAmount > 0 ? record.paymentAmount + ' грн.' : ''}
                            />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер фіскального чеку"}/>
                            <TextField source="paymentId"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Дата погашення"}/>
                            <TextField source="dispensedAt"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Ким погашено"}/>
                            <TextField source="dispensedBy"  />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </Show>
    );
};

export default ContractRequestShow;
